module.exports = __webpack_public_path__ + "img/photo@3x.81e22d45.jpg";